<div [formGroup]="form">
  <!-- Connect in Test Mode checkbox -->
  <div class="checkbox-group">
    <mat-checkbox id="{{ baseId }}-connect-in-test-mode-checkbox" formControlName="connectInTestMode" translate> Connect
      in Test Mode </mat-checkbox>
  </div>
  <!-- Connect in Test Mode checkbox -->

  <!-- Production Mode Settings start -->
  <section class="production-mode">
    <hr />
    <h4 id="{{ baseId }}-test-mode-settings-subtitle" translate>Production Mode Settings</h4>
    <!-- Gateway URL Control -->
    <div class="form-group">
      <label for="{{ baseId }}-gateway-url" translate>Gateway URL</label>
      <input id="{{ baseId }}-gateway-url" class="form-control"
        type="text"
        [ngClass]="{ error: showErrors(gatewayUrlControl, isSubmitted), 'required': isRequired(gatewayUrlControl) }"
        [maxlength]="fcListValidation.validations.GatewayUrl.MaxLength" formControlName="gatewayUrl" />
      <div *ngIf="showErrors(gatewayUrlControl, isSubmitted)" id="{{ baseId }}-warning-text-gateway-url"
        class="incorrect-input" translate>
        {{ gatewayUrlControl.errors | fcListValidation : 'GatewayUrl' }}
      </div>
    </div>
    <!-- Gateway URL  Control -->

    <div class="flex-row-generic">
      <!-- Gateway Login ID Control -->
      <div class="form-group flex-item-two-columns">
        <label for="{{ baseId }}-gateway-login-id" translate>Gateway Login ID</label>
        <input id="{{ baseId }}-gateway-login-id" class="form-control"
          type="text"
          [ngClass]="{ error: showErrors(gatewayLoginIDControl, isSubmitted), 'required': isRequired(gatewayLoginIDControl) }"
          [maxlength]="fcListValidation.validations.GatewayLoginID.MaxLength" formControlName="gatewayLoginID" />
        <div *ngIf="showErrors(gatewayLoginIDControl, isSubmitted)" id="{{ baseId }}-warning-text-gateway-login-id"
          class="incorrect-input" translate>
          {{ gatewayLoginIDControl.errors | fcListValidation : 'GatewayLoginID' }}
        </div>
      </div>
      <!-- Gateway Login ID Control -->

      <!-- Password Control -->
      <div class="form-group flex-item-two-columns">
        <label for="{{ baseId }}-password" translate>Password</label>
        <input id="{{ baseId }}-password" class="form-control"
          type="text"
          [ngClass]="{ error: showErrors(passwordControl, isSubmitted), 'required': isRequired(passwordControl) }"
          [maxlength]="fcListValidation.validations.Password.MaxLength" formControlName="password" />
        <div *ngIf="showErrors(passwordControl, isSubmitted)" id="{{ baseId }}-warning-text-password"
          class="incorrect-input" translate>
          {{ passwordControl.errors | fcListValidation : 'Password' }}
        </div>
      </div>
      <!-- Password Control -->
    </div>

    <!-- Mailbox URL Control -->
    <div class="form-group">
      <label for="{{ baseId }}-mailbox-url" translate>Mailbox URL</label>
      <input id="{{ baseId }}-mailbox-url" class="form-control"
        type="text"
        [ngClass]="{ error: showErrors(mailboxUrlControl, isSubmitted), 'required': isRequired(mailboxUrlControl) }"
        [maxlength]="fcListValidation.validations.MailboxUrl.MaxLength" formControlName="mailboxUrl" />
      <div *ngIf="showErrors(mailboxUrlControl, isSubmitted)" id="{{ baseId }}-warning-text-mailbox-url"
        class="incorrect-input" translate>
        {{ mailboxUrlControl.errors | fcListValidation : 'MailboxUrl' }}
      </div>
    </div>
    <!-- Mailbox URL  Control -->

    <div class="flex-row-generic">
      <!-- Mailbox Name Control -->
      <div class="form-group flex-item-two-columns">
        <label for="{{ baseId }}-mailbox-name" translate>Mailbox Name</label>
        <input id="{{ baseId }}-mailbox-nam" class="form-control"
          type="text"
          [ngClass]="{ error: showErrors(mailboxNameControl, isSubmitted), 'required': isRequired(mailboxNameControl) }"
          [maxlength]="fcListValidation.validations.MailboxName.MaxLength" formControlName="mailboxName" />
        <div *ngIf="showErrors(mailboxNameControl, isSubmitted)" id="{{ baseId }}-warning-text-mailbox-nam"
          class="incorrect-input" translate>
          {{ mailboxNameControl.errors | fcListValidation : 'MailboxName' }}
        </div>
      </div>
      <!-- Mailbox Name Control -->

      <!-- Mailbox Password Control -->
      <div class="form-group flex-item-two-columns">
        <label for="{{ baseId }}-mailbox-password" translate>Password</label>
        <input id="{{ baseId }}-mailbox-password" class="form-control"
          type="text"
          [ngClass]="{ error: showErrors(mailboxPasswordControl, isSubmitted), 'required': isRequired(mailboxPasswordControl) }"
          [maxlength]="fcListValidation.validations.MailboxPassword.MaxLength" formControlName="mailboxPassword" />
        <div *ngIf="showErrors(mailboxPasswordControl, isSubmitted)" id="{{ baseId }}-warning-text-mailbox-password"
          class="incorrect-input" translate>
          {{ mailboxPasswordControl.errors | fcListValidation : 'MailboxPassword' }}
        </div>
      </div>
      <!-- Mailbox Password Control -->
    </div>
  </section>
  <!-- Production Mode Settings end -->

  <!-- Test Mode Settings start -->
  <section class="test-mode">
    <hr />
    <h4 id="{{ baseId }}-test-mode-settings-subtitle" translate>Test Mode Settings</h4>
    <!-- Test Gateway URL Control -->
    <div class="form-group">
      <label for="{{ baseId }}-test-gateway-url" translate>Gateway URL</label>
      <input id="{{ baseId }}-test-gateway-url" class="form-control"
        type="text"
        [ngClass]="{ error: showErrors(testGatewayUrlControl, isSubmitted), 'required': isRequired(testGatewayUrlControl) }"
        [maxlength]="fcListValidation.validations.TestGatewayUrl.MaxLength" formControlName="testGatewayUrl" />
      <div *ngIf="showErrors(testGatewayUrlControl, isSubmitted)" id="{{ baseId }}-warning-text-test-gateway-url"
        class="incorrect-input" translate>
        {{ testGatewayUrlControl.errors | fcListValidation : 'TestGatewayUrl' }}
      </div>
    </div>
    <!-- Test Gateway URL  Control -->

    <div class="flex-row-generic">
      <!-- Test Gateway Login ID Control -->
      <div class="form-group flex-item-two-columns">
        <label for="{{ baseId }}-test-gateway-login-id" translate>Gateway Login ID</label>
        <input id="{{ baseId }}-test-gateway-login-id" class="form-control"
          type="text"
          [ngClass]="{ error: showErrors(testGatewayLoginIDControl, isSubmitted), 'required': isRequired(testGatewayLoginIDControl) }"
          [maxlength]="fcListValidation.validations.TestGatewayLoginID.MaxLength"
          formControlName="testGatewayLoginID" />
        <div *ngIf="showErrors(testGatewayLoginIDControl, isSubmitted)"
          id="{{ baseId }}-warning-text-test-gateway-login-id" class="incorrect-input" translate>
          {{ testGatewayLoginIDControl.errors | fcListValidation : 'TestGatewayLoginID' }}
        </div>
      </div>
      <!-- Test Gateway Login ID Control -->

      <!-- Test Password Control -->
      <div class="form-group flex-item-two-columns">
        <label for="{{ baseId }}-test-password" translate>Password</label>
        <input id="{{ baseId }}-test-password" class="form-control"
          type="text"
          [ngClass]="{ error: showErrors(testPasswordControl, isSubmitted), 'required': isRequired(testPasswordControl) }"
          [maxlength]="fcListValidation.validations.TestPassword.MaxLength" formControlName="testPassword" />
        <div *ngIf="showErrors(testPasswordControl, isSubmitted)" id="{{ baseId }}-warning-text-test-password"
          class="incorrect-input" translate>
          {{ testPasswordControl.errors | fcListValidation : 'TestPassword' }}
        </div>
      </div>
      <!-- Test Password Control -->
    </div>

    <!-- Test Mailbox URL Control -->
    <div class="form-group">
      <label for="{{ baseId }}-test-mailbox-url" translate>Mailbox URL</label>
      <input id="{{ baseId }}-test-mailbox-url" class="form-control"
        type="text"
        [ngClass]="{ error: showErrors(testMailboxUrlControl, isSubmitted), 'required': isRequired(testMailboxUrlControl) }"
        [maxlength]="fcListValidation.validations.TestMailboxUrl.MaxLength" formControlName="testMailboxUrl" />
      <div *ngIf="showErrors(testMailboxUrlControl, isSubmitted)" id="{{ baseId }}-warning-text-test-mailbox-url"
        class="incorrect-input" translate>
        {{ testMailboxUrlControl.errors | fcListValidation : 'TestMailboxUrl' }}
      </div>
    </div>
    <!-- Test Mailbox URL  Control -->

    <div class="flex-row-generic">
      <!-- Test Mailbox Name Control -->
      <div class="form-group flex-item-two-columns">
        <label for="{{ baseId }}-test-mailbox-name" translate>Mailbox Name</label>
        <input id="{{ baseId }}-test-mailbox-nam" class="form-control"
          type="text"
          [ngClass]="{ error: showErrors(testMailboxNameControl, isSubmitted), 'required': isRequired(testMailboxNameControl) }"
          [maxlength]="fcListValidation.validations.TestMailboxName.MaxLength" formControlName="testMailboxName" />
        <div *ngIf="showErrors(testMailboxNameControl, isSubmitted)" id="{{ baseId }}-warning-text-test-mailbox-nam"
          class="incorrect-input" translate>
          {{ testMailboxNameControl.errors | fcListValidation : 'TestMailboxName' }}
        </div>
      </div>
      <!-- Test Mailbox Name Control -->

      <!-- Test Mailbox Password Control -->
      <div class="form-group flex-item-two-columns">
        <label for="{{ baseId }}-test-mailbox-password" translate>Password</label>
        <input id="{{ baseId }}-test-mailbox-password" class="form-control"
          type="text"
          [ngClass]="{ error: showErrors(testMailboxPasswordControl, isSubmitted), 'required': isRequired(testMailboxPasswordControl) }"
          [maxlength]="fcListValidation.validations.TestMailboxPassword.MaxLength"
          formControlName="testMailboxPassword" />
        <div *ngIf="showErrors(testMailboxPasswordControl, isSubmitted)"
          id="{{ baseId }}-warning-text-test-mailbox-password" class="incorrect-input" translate>
          {{ testMailboxPasswordControl.errors | fcListValidation : 'TestMailboxPassword' }}
        </div>
      </div>
      <!-- Test Mailbox Password Control -->
    </div>
  </section>
  <!-- Test Mode Settings end -->

</div>